// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ynopvrcbsdutquwnszcm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inlub3B2cmNic2R1dHF1d25zemNtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIwNjIxMjYsImV4cCI6MjA1NzYzODEyNn0.dbFaJnUYmDZBNT3smok_MasyHh0s2k_a03KjG_oiKMI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);